import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 space-y-4">
      <p className="label-mono">404</p>
      <h1 className="font-display text-3xl text-text">Page not found</h1>
      <Link to="/jobs" className="text-accent hover:underline">
        Back to jobs
      </Link>
    </div>
  );
}
